import { PriceManagerDatapointsModel } from '../../hooks/usePriceManagerDatapointsModel';
import { getTotalPrices } from '../../services';

export const totalPriceQuery = (priceManagerDatapointsModel?: PriceManagerDatapointsModel) => {
  return {
    queryKey: ['totalPrices', priceManagerDatapointsModel],
    queryFn: () => getTotalPrices(priceManagerDatapointsModel),
  };
};
